module.exports = __webpack_public_path__ + "/c4d913eb18621044de64bd53dcbc2218.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/assets/name_icon.svg
 ** module id = 1112
 ** module chunks = 0
 **/